import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/kenaikanpangkatService'
import IndexBloc from '../../Index/Blocs/IndexBloc'

class UpdateSKModal extends Component {

    indexBloc = new IndexBloc()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            optionSignatureOfficer: [
                { label: "Kepala Biro Umum", value: "Kepala Biro Umum" },
                { label: "Sekretariat Utama", value: "Sekretariat Utama" },
                { label: "Atas Nama", value: "Atas Nama" }
            ],
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        var userdata = JSON.parse(localStorage.getItem('userdata'))
        var create_uuid = userdata.employee_uuid;
        this.setState({
            dataForm: {
                create_uuid : create_uuid,
                uuid: this.props.uuid,
                employee_nip: this.props.nip,
                ...values
            },
            confirm: true
        })
        
    }

    submitData = async () => {
        console.log(this.state.dataForm)
        // await this.reportBloc.fetchReport(this.state.dataForm)
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.indexBloc.fetchUpdateSuratKeputusan(dataForm)
        // if (this.props.uuid === '') {
        //     await this.createBloc.fetchCreate(this.state.dataForm)
        // } else {
        //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
        // }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
    }

    componentDidMount() {
        this.setTokenAPI()
        this.indexBloc.updateSuratKeputusanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    //this.props.setUuid(result.data.response.employee_transfer_uuid)
                    //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.props.toggle()
                    this.props.handleReload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    this.props.toggle()
                    break
                default:
                    break;
            }
        })
        this.indexBloc.uploadDecreeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    //this.props.setUuid(result.data.response.employee_transfer_uuid)
                    //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.props.toggle()
                    this.props.handleReload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    this.props.toggle()
                    break
                default:
                    break;
            }
        })
    }

    componentWillUnmount() {
        this.indexBloc.updateSuratKeputusanChannel?.unsubscribe();
        this.indexBloc.uploadDecreeChannel?.unsubscribe();
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                    >
                        <ModalHeader toggle={this.props.toggle}>Update Dokumen Mutasi Surat Keputusan</ModalHeader>
                        <ModalBody>

                            <dl class="row mb-0">
                                <dt class="col-sm-3">NIP</dt>
                                <dd class="col-sm-9">{this.props.nip}</dd>

                                <dt class="col-sm-3">Nama</dt>
                                <dd class="col-sm-9">{this.props.nama}</dd>
                            </dl>
                            <hr></hr>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    Nomor SK <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Nomor SK"
                                        name="employee_transfer_detail_decree_number"
                                        type="text"
                                        validate={{ required: { value: true } }}
                                        value={this.props.employee_transfer_detail_decree_number}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    Tanggal SK <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Nomor SK"
                                        name="employee_transfer_detail_decree_date"
                                        type="date"
                                        validate={{ required: { value: true } }}
                                        value={this.props.employee_transfer_detail_decree_date}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    TMT Mulai <span className="text-danger">*</span>
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Nomor SK"
                                        name="employee_transfer_detail_tmt_date"
                                        type="date"
                                        validate={{ required: { value: true } }}
                                        value={this.props.employee_transfer_detail_tmt_date}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    TMT Berakhir
                                </Label>
                                <Col md="9">
                                    <AvField
                                        placeholder="Nomor SK"
                                        name="employee_transfer_detail_tmt_date_end"
                                        type="date"
                                        value={this.props.employee_transfer_detail_tmt_date_end}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Label
                                    className="col-md-3 col-form-label"
                                >
                                    Dokumen SK
                                </Label>
                                <Col md="9">
                                    <FileInput
                                        name="file"
                                        placeholder="Dokumen SK"
                                        className="form-control"
                                        col="6"
                                    />
                                    {this.props.document_decree != null ?<a target={"_blank"} href={this.props.document_decree}>[Dokumen Sebelumnya]</a>: ''}
                                </Col>
                            </Row>



                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>{' '}
                            <Button color="primary" type="submit">Submit</Button>
                        </ModalFooter>
                    </AvForm>

                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}

export default withRouter(UpdateSKModal)